// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import NavButton from '../NavButton';
import type { CategoryType, LinkGroupType } from '../types';
import ExpanderAnimation from '../../../../../internal/ExpanderAnimation';

type LinkMenuType = {|
  name: string,
  link?: string,
  categories: Array<CategoryType>,
|};

type PropTypes = {|
  supportHref: string,
  loginHref: string,
  buyHref: string,
  linkMenu: Array<LinkMenuType>,
|};

const LinkGroup = (props: LinkGroupType) => {
  const [open, toggle] = React.useState(false);

  const onClick = () => {
    toggle(!open);
  };

  return (
    <>
      <button className={cx(styles.linkGroup, open && styles.isOpen)} onClick={onClick}>
        {props.name}
      </button>
      <ExpanderAnimation open={open}>
        {props.links &&
          props.links.map(link => (
            <NavButton variant="Link" href={link.href}>
              {link.name}
            </NavButton>
          ))}
      </ExpanderAnimation>
    </>
  );
};

export default (props: PropTypes) => {
  const [level, onChange] = React.useState([]);
  let items = [
    ...props.linkMenu.map(menuItem =>
      menuItem.categories.length === 0 ? (
        <NavButton href={menuItem.link || '#'} variant="MenuLinkNoChildren">
          {menuItem.name}
        </NavButton>
      ) : (
        <NavButton onClick={() => onChange([menuItem.name])} variant="MenuLink">
          {menuItem.name}
        </NavButton>
      ),
    ),

    <NavButton href={props.supportHref} variant="MenuLinkNoChildren">
      Support
    </NavButton>,

    props.buyHref ? (
      <NavButton
        href={props.buyHref}
        variant="Button"
        analyticsEvent={{
          event: 'f_website_try-now-for-free.clicked',
          properties: {
            clicked_from: 'side_nav',
          },
        }}
      >
        Start for FREE
      </NavButton>
    ) : null,

    <NavButton href={props.loginHref} variant="LoginLink">
      Log in
    </NavButton>,
  ].filter(Boolean);

  if (level && level.length > 0) {
    const menuItem = props.linkMenu.find(item => item.name === level[0]);

    if (menuItem) {
      items = [
        <NavButton onClick={() => onChange(level.slice(0, -1))} variant="BackMenu">
          {menuItem.name}
        </NavButton>,

        ...menuItem.categories.map(category =>
          category.links && category.links.length === 1 ? (
            <NavButton href={category.links[0].href} variant="CategoryLinkNoChildren">
              {category.links[0].name}
            </NavButton>
          ) : (
            <NavButton onClick={() => onChange([...level, category.name])} variant="CategoryLink">
              {category.name}
            </NavButton>
          ),
        ),
      ];
    }

    if (menuItem && level.length === 2) {
      const currentCategory = menuItem.categories.find(category => category.name === level[1]);
      if (currentCategory) {
        let links = [];

        if (currentCategory.links) {
          links = currentCategory.links.map(link => (
            <NavButton href={link.href} variant="Link">
              {link.name}
            </NavButton>
          ));
        }

        if (currentCategory.linkGroups) {
          links = currentCategory.linkGroups.map(group => (
            <LinkGroup name={group.name} links={group.links} />
          ));
        }

        items = [
          <NavButton onClick={() => onChange(level.slice(0, -1))} variant="BackCategory">
            {currentCategory.name}
          </NavButton>,
          ...links,
        ];
      }
    }
  }

  return (
    <ul>
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};
